<template>
    <div class="layout-px-spacing">
        <teleport to="#breadcrumb">
            <ul class="navbar-nav flex-row">
                <li>
                    <div class="page-header">
                        <nav class="breadcrumb-one" aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <router-link to="/violation/actions_taken/view">Actions Taken</router-link>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                    <span>Add Action Taken</span>
                                </li>
                            </ol>
                        </nav>
                    </div>
                </li>
            </ul>
        </teleport>

        <div class="row layout-top-spacing">
            <div class="col-xl-10 col-lg-10 col-md-12 col-12 layout-spacing">
                <div class="panel br-4">
                    <div class="panel-body">
                        <router-link to="/violation/actions_taken/view" class="btn btn-danger mb-2 me-2">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="feather feather-arrow-left">
                                <line x1="19" y1="12" x2="5" y2="12"></line>
                                <polyline points="12 19 5 12 12 5"></polyline>
                            </svg>
                            Back to Actions Taken
                        </router-link>

                        <h6 class="mb-4">Add your Action Taken Details</h6>

                        <!-- Form -->
                        <form @submit.prevent="submitForm">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="mb-4">
                                        <label for="name" class="form-label">Action Taken Name</label>
                                        <input v-model="form.name" type="text" id="name" class="form-control"
                                            placeholder="Enter action name" required :disabled="loading" />
                                        <div class="form-text text-end">{{ form.name.length }}/255</div>
                                        <div v-if="errors.name" class="text-danger small mt-1">
                                            {{ errors.name }}
                                        </div>
                                    </div>

                                    <div class="mb-4">
                                        <label class="form-label">Status</label>
                                        <select v-model="form.is_active" class="form-select" :disabled="loading">
                                            <option :value="true">Active</option>
                                            <option :value="false">Inactive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>

                            <div class="text-center mt-4">
                                <button type="submit" class="btn btn-success me-3" :disabled="loading">
                                    <template v-if="loading">
                                        <span class="spinner-border spinner-border-sm me-2" role="status"
                                            aria-hidden="true"></span>
                                        Processing...
                                    </template>
                                    <template v-else>
                                        Submit
                                    </template>
                                </button>
                                <button type="button" class="btn btn-secondary" @click="resetForm"
                                    :disabled="loading">
                                    Reset
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { useMeta } from "@/composables/use-meta";
import { ref } from 'vue';
import axios from 'axios';
import { BASE_URL } from '@/Config/config';
import Swal from 'sweetalert2';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

useMeta({ title: "Add Action Taken" });

const store = useStore();
const router = useRouter();
const loading = ref(false);
const errors = ref({});

const form = ref({
    name: '',
    is_active: true
});

const showAlert = (icon, title, text) => {
    Swal.fire({
        icon,
        title,
        text,
        confirmButtonColor: '#3085d6',
    });
};

const resetForm = () => {
    form.value = {
        name: '',
        is_active: true
    };
    errors.value = {};
};

const submitForm = async () => {
    loading.value = true;
    errors.value = {};

    try {
        const response = await axios.post(`${BASE_URL}/taken-actions`, {
            name: form.value.name,
            is_active: form.value.is_active
        }, {
            headers: {
                'Authorization': `Bearer ${store.state.token}`,
                'X-Company-ID': store.state.currentCompany?.id
            }
        });

        showAlert('success', 'Success!', 'Action taken created successfully');
        // router.push('/violation/actions_taken/view');

        // Reset form fields
        form.value = {
            name: '',
            is_active: true
        };

    } catch (error) {
        if (error.response) {
            // Handle validation errors
            if (error.response.status === 422) {
                errors.value = error.response.data.errors || {};
                showAlert('error', 'Validation Error', 'Please correct the highlighted fields');
            } else {
                showAlert('error', 'Error', error.response.data.message || 'Failed to create action taken');
            }
        } else {
            showAlert('error', 'Network Error', 'Please check your internet connection');
        }
    } finally {
        loading.value = false;
    }
};
</script>

<style scoped>
.layout-px-spacing {
    min-height: calc(100vh - 170px) !important;
}

.panel {
    background-color: #fff;
    border-radius: 0.5rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}

.panel-body {
    padding: 1.5rem;
}

.form-label {
    font-weight: 500;
    margin-bottom: 0.5rem;
}

.btn-lg {
    padding: 0.5rem 1.5rem;
    font-size: 1.1rem;
}
</style>